import { convertStyleData, transformPx2Rem } from '@utils/tools';
import { customEvent } from '@utils/customEvent';

import './TitleEleCustomComponent.less';

export default function TitleEleCustomComponent(props) {
  /**
   * 传入数据
   */ 
  const data = props.data;                // 组件数据
  const detailData = props.detailData;    // 详情页数据
  const dynamicData = props.dynamicData;  // 动态数据
  /**
   * 组件配置对象
   */  
  const customFeature = data.customFeature;
  /**
   * 样式数据处理
   */
  const styleObj = convertStyleData(data.style);
  /**
   * 组件内容处理
   */   
  let content = data.content;
  const segment = data.customFeature.segment; // 已绑定字段
  // 是否有绑定字段
  if (segment) {
    if (detailData && detailData[segment]) {
      content = detailData[segment];    // 当前组件处于详情页数据并已绑定某字段
    } else if (dynamicData && dynamicData[segment]) {
      content = dynamicData[segment];   // 当前组件有动态数据并已绑定某字段（TODO: 如果content为富文本，需要处理）
    }
  }
  /**
   * 标记样式
   */ 
  const markStyleObj = {
    backgroundColor: customFeature['markColor'],
  };
  if (customFeature.mode === 0) {
    markStyleObj['display'] = 'none';
  } else if (customFeature.mode === 1 || customFeature.mode === 3) {
    markStyleObj['left'] = `-${transformPx2Rem(customFeature['markMargin-right'], 320)}`;
  } else if (customFeature.mode === 2) {
    markStyleObj['marginTop'] = `${transformPx2Rem(customFeature['markMargin-top'], 320)}`;
  }
  /**
   * 返回组件
   */ 
  return (
    <div className={`custom-component title-ele mode-${customFeature.mode}`} style={styleObj} onClick={() => customEvent({customFeature})}>
      <div className="title-content">
        <div className="title-text">
          <div className="mark" style={markStyleObj}></div>
          {content}
        </div>
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/title-ele-custom-component/TitleEleCustomComponent.jsx